import * as IDB from "@/services/indexedDB.service";
import { stripExtension, stripTimestampAndExtension } from '@/assets/js/Utilities';
import download from 'downloadjs';
import { CopyPass } from "postprocessing";

import $ from 'jquery';

export default class Lutify {
	constructor() {
		this.blocks = [];
		this.activeBlock = null;
		this.sampleData = [];
		this.sampleDataInt = [];
		this.canvasMouseDown = false;
		this.moveEnabled = true;
		this.splitViewActive = false;
		this.compares = [];
		this.matches = [];
		this.tempHiddenChanges = false
		this.opacity = 1;
		this.rotation = 0;
		this.splitSlider = 0.5;

		this.exportingLut = false;

		this.imageWidth = 0;
		this.imageHeight = 0;
		this.activeImageWidth = 0;
		this.activeImageHeight = 0;
		// this.imageName = "Original";
		this.imageRatio = null;
		this.originalImageSize = {
			width: null,
			height: null,
		};
		// this.imageSrc = null;

		this.selectedPreviewCategory = null;
		this.appliedLutsList = {};
		this.initLoad = {
			headersLoaded: {
				luts: false,
			},
			lutsSize: {
				luts: 0, //packages  + custom? luts
			},
			totalLutsSize: 0,
			loadedPercentage: 0,
			loadedLutsSize: {
				looks: 0,
			},
		};

		this.looks = [];
		this.selectedLookId = null;

		this.isMobile = false;
		this.fullscreen = false;

		this.maxCanvasSize = {
			width: 2048,
			height: 2048,
		};

		this.selectedIDT = null;
		this.selectedODT = null;

		this.activeModal = null;
		this.modalSelectedCategory = null;
		this.selectedPresetFolder = null;

		this.activeSidebarContainer = "tools";
		this.activePreviewsSidebarContainer = "project";

		this.savedLUT = [];

		this.magicMode = {
			isApplied: false,
			activeStep: null,
		};

		this.AIMagicMode = {
			isApplied: false,
			activeStep: null,
		};

		this.scopes = {
			active: false,
			selected: "parade",
			interval: null,
			lastUpdate: null,
		};

		this.fetchedPresets = {};
		this.lastImportedPreset = {};

		this.customBlocks = {};

		this.fixBlueLightArtifacts = false;
		this.gamutCompress = false;

		this.projects = [];
		this.intervals = {};

		this.applyingCandidate = false;

		this.imageThumbnail = {
			maxWidth: 300,
			maxHeight: 300,
			quality: 1,
		};

		this.matchThumbnail = {
			maxWidth: 300,
			maxHeight: 300,
			quality: 1,
		};
		this.candidateThumbnail = {
			maxWidth: 600,
			maxHeight: 600,
			quality: 1,
		};
		this.projectThumbnail = {
			maxWidth: 400,
			maxHeight: 400,
			quality: 1,
		};

		this.commentUpload = {
			maxWidth: 2048,
			maxHeight: 2048,
			quality: 1,
		};

		this.detectMobile();
	}

	detectMobile() {
		if (
			navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPod/i) ||
			navigator.userAgent.match(/BlackBerry/i) ||
			navigator.userAgent.match(/Windows Phone/i)
		) {
			this.isMobile = true;
		}
	}

	isHeadersLoaded() {
		if (
			this.initLoad.headersLoaded.luts === true &&
			this.initLoad.headersLoaded.conversion === true &&
			this.initLoad.headersLoaded.exposure === true &&
			this.initLoad.headersLoaded.contrast === true &&
			this.initLoad.headersLoaded.wb === true
		) {
			return true;
		} else return false;
	}

	setAppLoadedPercentage() {
		this.initLoad.loadedPercentage =
			((this.initLoad.loadedLutsSize.exposure +
					this.initLoad.loadedLutsSize.contrast +
					this.initLoad.loadedLutsSize.wb +
					this.initLoad.loadedLutsSize.conversions +
					this.initLoad.loadedLutsSize.looks +
					this.initLoad.loadedLutsSize.customs) /
				this.initLoad.totalLutsSize) *
			100;

		UI.updateInitLoadProgressBar(this.initLoad.loadedPercentage);
	}

	setImageData(width, height) {
		// if (loader.imageName) {
		// 	this.imageName = loader.imageName.substring(0, loader.imageName.lastIndexOf("."));
		// }
		this.imageWidth = width;
		this.imageHeight = height;
		this.activeImageWidth = width;
		this.activeImageHeight = height;
	}

	async saveMainImage(type = "png", imageTitle, options = {}, immediateDownload = true) {
		if (imageTitle == "") imageTitle = loader.imageName;

		await vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		let activeMediaClone = {};

		if (loader.typeOfActiveMedia('raw')) {
			gpu.swapComposerRenderer("export");

			activeMediaClone.imageData = loader.activeMedia.rawDevelopment.imageData;
			activeMediaClone.blob = loader.activeMedia.rawDevelopment.blob;
			activeMediaClone.url = loader.activeMedia.rawDevelopment.url;
			activeMediaClone.type = loader.activeMedia.rawDevelopment.type;
			activeMediaClone.values = loader.activeMedia.rawDevelopment.values;

			loader.activeMedia.rawDevelopment.imageData = null;
			loader.activeMedia.rawDevelopment.blob = null;
			loader.activeMedia.rawDevelopment.url = null;
			loader.activeMedia.rawDevelopment.type = null;
			loader.activeMedia.rawDevelopment.values = null;

			let rawImageData;
			if (vm.rawDevelopment.values.develop) {
				const developRawParemeters = vm.rawDevelopment.getDevelopParameters({
					exportingImage: true,
					...vm.rawDevelopment.getValues()
				});

				rawImageData = await vm.rawDevelopment.getDevelopedImage(vm.$store.state.Projects.image, developRawParemeters, true);
			} else {
				rawImageData = await vm.rawDevelopment.getThumbnail(vm.$store.state.Projects.image);
			}

			window.loader.setActiveMediaForRaw(rawImageData);

			await gpu.initNewImage();
			await vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
			// let texture = await gpu.getActiveMediaTexture();
		}

		gpu.swapComposerRenderer("export");

		if (loader.typeOfActiveMedia('raw')) gpu.texture.anisotropy = gpu.renderer.capabilities.getMaxAnisotropy();

		let originalCameraZoom = gpu.camera.zoom;
		let originalCameraPositionX = gpu.camera.position.x;
		let originalCameraPositionY = gpu.camera.position.y;
		gpu.camera.zoom = 1;
		gpu.camera.position.x = 0;
		gpu.camera.position.y = 0;
		gpu.camera.updateProjectionMatrix();
		gpu.render();

		let imageDataUrl;

		if (type == "png") {
			imageDataUrl = gpu.exportRenderer.domElement.toDataURL();
			if (immediateDownload) download(imageDataUrl, imageTitle + ".png", "image/png");
		} else if (type == "jpg") {
			imageDataUrl = gpu.exportRenderer.domElement.toDataURL("image/jpeg", options.jpgQuality);
			if (immediateDownload) download(imageDataUrl, imageTitle + ".jpg", "image/jpeg");
		} else if (type == "tiff") {
			// TODO maybe we could skip reading from renderer canvas and provide the export canvas directly to the tiff library?
			let exportCanvasDataUrl = gpu.exportRenderer.domElement.toDataURL();
			let canvas = document.getElementById("tiff-export-canvas");
			let ctx = canvas.getContext("2d");
			let img = new Image();
			img.src = exportCanvasDataUrl;
			await img.decode();
			canvas.width = img.width;
			canvas.height = img.height;
			ctx.drawImage(img, 0, 0);
			await new Promise(resolve => {
				CanvasToTIFF.toDataURL(canvas, tiffDataUrl => {
					imageDataUrl = tiffDataUrl;
					if (immediateDownload) download(imageDataUrl, imageTitle + ".tiff", "image/tiff");
					resolve();
				}, {
					littleEndian: true
				});
			})
		}

		gpu.texture.anisotropy = 1;
		gpu.swapComposerRenderer("main");

		if (loader.typeOfActiveMedia('raw')) {
			if (loader.activeMedia.rawDevelopment.url) {
				URL.revokeObjectURL(loader.activeMedia.rawDevelopment.url)
			}

			loader.activeMedia.rawDevelopment.imageData = activeMediaClone.imageData;
			loader.activeMedia.rawDevelopment.blob = activeMediaClone.blob;
			loader.activeMedia.rawDevelopment.url = activeMediaClone.url;
			loader.activeMedia.rawDevelopment.type = activeMediaClone.type;
			loader.activeMedia.rawDevelopment.values = activeMediaClone.values;
			await gpu.initNewImage();
		}

		gpu.camera.zoom = originalCameraZoom;
		gpu.camera.position.x = originalCameraPositionX;
		gpu.camera.position.y = originalCameraPositionY;
		gpu.camera.updateProjectionMatrix();
		gpu.render();
		if (immediateDownload) await vm.$store.dispatch("Loader/showProgressBar", false);

		return imageDataUrl;
	}

	// exportImages(view) {
	// 	let imgNumber, imgArray, dataURL, canvasName;

	// 	imgArray = UI.container.compares.find("img");
	// 	imgNumber = imgArray.length;

	// 	// If number of exporting images is 1
	// 	if (imgNumber == 1) {
	// 		canvasName =
	// 			imgArray
	// 				.eq(0)
	// 				.closest(".compare-container")
	// 				.find(".compare-name")
	// 				.html() + ".png";
	// 		// if (canvasName === '') canvasName = 'Original.png';
	// 		dataURL = imgArray.eq(0).attr("src");
	// 		download(dataURL, canvasName, "image/png");
	// 	}

	// 	// Else if number of exporting image is greater than 1
	// 	else if (imgNumber > 1) {
	// 		console.log(imgArray);
	// 		let zip = new JSZip();
	// 		imgArray.each(function() {
	// 			canvasName =
	// 				$(this)
	// 					.closest(".compare-container")
	// 					.find(".compare-name")
	// 					.html() + ".png";

	// 			if (
	// 				$(this)
	// 					.attr("src")
	// 					.indexOf("data:image/png;base64,") > -1
	// 			) {
	// 				dataURL = $(this)
	// 					.attr("src")
	// 					.split("data:image/png;base64,")[1];
	// 			} else if (
	// 				$(this)
	// 					.attr("src")
	// 					.indexOf("data:image/jpg;base64,") > -1
	// 			) {
	// 				dataURL = $(this)
	// 					.attr("src")
	// 					.split("data:image/jpg;base64,")[1];
	// 			}

	// 			zip.file(canvasName, dataURL, { base64: true });
	// 		});

	// 		// zip everything and download
	// 		zip.generateAsync({ type: "blob" }).then(blob => saveAs(blob, "lutify_export_" + Date.now() + ".zip"));
	// 	}
	// }

	checkImageSize() {
		this.setImageRatio();
		this.setOriginalImageSize();
		this.isImageSizeChanged = false;

		if (this.imageWidth >= this.imageHeight) {
			if (this.imageWidth >= this.maxCanvasSize.width) {
				this.imageWidth = this.maxCanvasSize.width;
				this.imageHeight = this.imageWidth / this.imageRatio;
				this.activeImageWidth = this.imageWidth;
				this.activeImageHeight = this.imageHeight;
				this.isImageSizeChanged = true;
			}
		} else {
			if (this.imageHeight >= this.maxCanvasSize.height) {
				this.imageHeight = this.maxCanvasSize.height;
				this.imageWidth = this.imageHeight / this.imageRatio;
				this.activeImageWidth = this.imageWidth;
				this.activeImageHeight = this.imageHeight;
				this.isImageSizeChanged = true;
			}
		}
	}

	getConstrainedImageSize(width, height) {
		let ratio = this.getImageRatio(width, height);

		if (width >= height) {
			if (width >= this.maxCanvasSize.width) {
				width = this.maxCanvasSize.width;
				height = width / ratio;
			}
		} else {
			if (height >= this.maxCanvasSize.height) {
				height = this.maxCanvasSize.height;
				width = height / ratio;
			}
		}

		return {width, height}
	}

	setImageRatio() {
		if (this.imageWidth >= this.imageHeight) this.imageRatio = this.imageWidth / this.imageHeight;
		else this.imageRatio = this.imageHeight / this.imageWidth;
	}

	getImageRatio(width, height) {
		if (width >= height) return width / height;
		else return height / width;
	}

	setOriginalImageSize() {
		this.originalImageSize.width = this.imageWidth;
		this.originalImageSize.height = this.imageHeight;
	}

	afterInitialIDTselected(IDTindex) {
		this.selectedIDT = luts.IDT[IDTindex];

		let ODTname = this.getODTtitleFromCombination(IDTindex);
		this.selectedODT = this.getODTbyName(ODTname);

		// gpu.setLastPass_renderToScreen(false);

		// gpu.addInitialIDTpass(this.selectedIDT);
		// gpu.addInitialODTpass(this.selectedODT);
		// gpu.addDitheringPass();

		gpu.updateIDT(this.selectedIDT);
		gpu.updateODT(this.selectedODT);

		UI.IDT.btn.find(".menu-label").html(this.selectedIDT.label);
		UI.ODT.btn.find(".menu-label").html(this.selectedODT.label);

		if (!lutify.gamutCompress) {
			vm.$nextTick(() => {
				vm.$root.$refs.gamutCompressButton.$el.click();
			})
		}

		if (this.selectedIDT.value == "IDT100") {
			UI.showColorWorkflowNotification();
			if (lutify.gamutCompress) {
				vm.$nextTick(() => {
					vm.$root.$refs.gamutCompressButton.$el.click();
				})
			}
		}
	}

	getODTtitleFromCombination(IDTindex, IDTvalue = null) {
		if (IDTindex == undefined) IDTindex = luts.IDT.map(e => e.value).indexOf(IDTvalue);

		let ODTtitle;
		config.IDT_ODT_combinations.forEach(combination => {
			if (combination.IDT == luts.IDT[IDTindex].name) ODTtitle = combination.ODT;
			else if (combination.IDT == "") ODTtitle = combination.ODT;
		});
		return ODTtitle;
	}

	getODTbyName(ODTname) {
		let ODT;
		luts.ODT.forEach(ODTdata => {
			if (ODTdata.name == ODTname) ODT = ODTdata;
		});
		return ODT;
	}

	getActiveBlock() {
		let blockNum = blocks.getBlockIndex_byBlockNum(this.activeBlock);
		return this.blocks[blockNum] ? this.blocks[blockNum] : null;
	}

	setActiveBlock(number) {
		this.activeBlock = number;
	}

	async resetScene() {
		this.selectedPreviewCategory = null;

		if (this.fixBlueLightArtifacts) {
			vm.$nextTick(() => {
				vm.$root.$refs.fixBlueLightButton.$el.click();
			})
		}
		if (!this.gamutCompress) {
			vm.$nextTick(() => {
				vm.$root.$refs.gamutCompressButton.$el.click();
			})
		}

		blocks.removeAllDynamic();
		await this.applyLastState();
		await this.storeLastState();

		this.updateImageThumbnail();

		if (loader.typeOfActiveMedia('raw')) {
			vm.rawDevelopment.resetBlock();
		} else {
			UI.setUIToInitial();
		}

		UI.toggleStartTips();
	}

	refreshSplitView(match = undefined) {
		$("#twentyContainer").remove();
		if (!match) match = vm.$store.state.Projects.match;
		this.setSplitView(match.id);
		vm.$store.dispatch("Projects/selectMatch", match);
	}



	async setSplitView(matchIndex = undefined) {
		lutify.splitViewActive = true;
		vm.$store.dispatch('UI/setSplitView', true);

		if (typeof matchIndex !== "undefined") {
			let matchData = await matchesStore.getItem(matchIndex);
			if (!matchData) matchData = await uploadMatchesStore.getItem(matchIndex);

			let image = new Image();
			let objectURL = URL.createObjectURL(matchData.blob);
			// console.info(`[CREATE URL][MATCH][SELECTED] ${objectURL}`);

			image.src = objectURL;
			image.onload = () => {
				vm.$store.dispatch("Helpers/revokeObjectURL", objectURL);
				UI.showSplitView(image);
			};
		} else {
			let image = new Image();
			image.src = gpu.getOriginalImageSrc();
			image.onload = () => UI.showSplitView(image);
		}
	}

	removeSplitView() {
		lutify.splitViewActive = false;
		vm.$store.dispatch('UI/setSplitView', false);

		UI.container.matches.find(".selected").removeClass("selected");

		$("#twentyContainer").fadeOut(500, function() {
			$(".twentytwenty-wrapper").remove();
			vm.$store.dispatch('UI/setSplitView', false);
		});

		vm.$store.dispatch("Projects/deselectMatch");
	}

	async fetchImage(file) {
		let storeData = await window.uploadImagesStore.getItem(file.id); // first check upload store
		if (!storeData) storeData = await window.imagesStore.getItem(file.id); // then check images store

		if (!storeData) {
			let blob = await vm.$store.dispatch("Projects/fetchFile", file.presignedURL);
			// console.log(`[IMAGE] [${file.id}] fetched from S3`);

			storeData = {
				id: file.id,
				// file: fetchedFile,
				name: stripExtension(file.name),
				fileType: file.name.substring(file.name.lastIndexOf(".") + 1),
				// src,
				blob,
				project_id: vm.$store.state.Projects.project.id,
				bin_id: file.bin_id,
			};

			window.imagesStore.setItem(file.id, storeData); // saving image to indexedDB
		}

		return storeData;
	}

	async fetchMatch(match) {
		let matchStoreData = await uploadMatchesStore.getItem(match.id);
		if (!matchStoreData) matchStoreData = await matchesStore.getItem(match.id);

		// if not in local storage, fetch from server
		if (!matchStoreData) {
			let blob = await vm.$store.dispatch("Projects/fetchFile", match.presignedURL);

			let imageIDTLMT;
			if (match.imageIDTLMT) {
				imageIDTLMT = await vm.$store.dispatch("Projects/fetchFile", match.imageIDTLMT.presign_url);
			}

			let blocksJSON = new File([await vm.$store.dispatch("Projects/fetchFile", match.blocks.presign_url)], match.blocks.name);
			let blocks = await this.convertBlobToData(blocksJSON);

			let rawDevelopmentBlock = blocks.find(block => block.name == 'RawDevelopment');
			if (rawDevelopmentBlock) {
				blocks = blocks.filter(block => block.name !== 'RawDevelopment');
			}

			// let lutFiles = [];
			// for await (const lut of match.luts) {
			// 	lutFiles.push(new File([await vm.$store.dispatch("Projects/fetchFile", lut.presign_url)], lut.name));
			// }

			matchStoreData = {
				id: match.id,
				blob,
				name: match.name,
				nicename: stripTimestampAndExtension(match.name),
				parent_id: match.parent_id,
				bin_id: match.bin_id,
				type: "match",
				// luts: lutFiles,
				imageIDTLMT,
				blocks,
				...(rawDevelopmentBlock && { rawDevelopment: rawDevelopmentBlock.values }),
			};

			matchesStore.setItem(match.id, matchStoreData);
		}

		return matchStoreData;
	}

	 getIDTLMTimage(passes = false, resizeCanvas = true, addCopyPass = true) {
		let originalPasses = gpu.composer.passes;
		if (passes) gpu.composer.passes = [...passes];
		else {
			passes = [...gpu.composer.passes];
			passes.splice(-1,1); // removing ODT

			let filteredPasses = [];
			passes.forEach(pass => {
				if (pass.name !== "DitherPass") filteredPasses.push(pass);
			});
			gpu.composer.passes = filteredPasses;
		}

		if (addCopyPass) gpu.composer.addPass(new CopyPass);

		if (resizeCanvas) {
			UI.exportCanvas.setSize(lutify.imageWidth, lutify.imageHeight);

			let drawingBufferSize = gpu.getDrawingBufferSize(gpu.exportRenderer);
			gpu.exportRenderer.setSize(drawingBufferSize.width, drawingBufferSize.height, false);
		}

		gpu.swapComposerRenderer("export");
		let originalCameraZoom = gpu.camera.zoom;
		let originalCameraPositionX = gpu.camera.position.x;
		let originalCameraPositionY = gpu.camera.position.y;
		gpu.camera.zoom = 1;
		gpu.camera.position.x = 0;
		gpu.camera.position.y = 0;
		gpu.camera.updateProjectionMatrix();

		gpu.render();
		const img = gpu.composer.renderer.domElement.toDataURL("image/jpeg", 1);

		gpu.swapComposerRenderer("main");
		gpu.composer.passes = originalPasses;
		gpu.camera.zoom = originalCameraZoom;
		gpu.camera.position.x = originalCameraPositionX;
		gpu.camera.position.y = originalCameraPositionY;
		gpu.camera.updateProjectionMatrix();
		gpu.render();

		if (resizeCanvas) {
			if (lutify.canSaveFullSizeImage()) UI.exportCanvas.setSize(lutify.originalImageSize.width, lutify.originalImageSize.height);
			else UI.exportCanvas.setSize(lutify.imageWidth, lutify.imageHeight);

			let drawingBufferSize = gpu.getDrawingBufferSize(gpu.exportRenderer);
			gpu.exportRenderer.setSize(drawingBufferSize.width, drawingBufferSize.height, false);
		}

		return img;
	}

	async addMatch(name) {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

		// placeholder on right
		await UI.appendToMatches({
			bin_id: vm.$store.state.Projects.bin.id,
			placeholder: true
		}, false);

		let date = Date.now();

		gpu.render();
		let img = gpu.composer.renderer.domElement.toDataURL("image/jpeg", 1);
		let imageIDTLMT = this.getIDTLMTimage(null, false);
		imageIDTLMT = loader.dataURLtoFile(imageIDTLMT, `${name}.imageIDTLMT.${date}.jpg`);

		let file = loader.dataURLtoFile(img, name);
		let thumbnailBlob = await readAndCompressImage(file, {
			quality: this.matchThumbnail.quality,
			maxWidth: this.matchThumbnail.maxWidth,
			maxHeight: this.matchThumbnail.maxHeight,
		});
		let thumbnailFile = new File([thumbnailBlob], `${name}.thumbnail.${date}.jpg`);

		let blocks = _.cloneDeep(this.getRawBlocksData());
		let blocksCopy = [...blocks];
		let rawDevelopmentValues = { ...vm.rawDevelopment.values };
		if (loader.typeOfActiveMedia('raw')) {
			blocksCopy.unshift({
				name: 'RawDevelopment',
				values: rawDevelopmentValues,
			});
		} else {
			rawDevelopmentValues = null;
		}

		let blocksFile = new File([JSON.stringify(blocksCopy)], `${name}.${date}.json`, { type: "application/json" });

		let exportedLUT1 = await luts.prepareExportLuts({
			name,
			options: {
				ACESinput: true,
				ACESoutput: true,
			},
		});

		let exportedLUT2 = await luts.prepareExportLuts({
			name,
			options: {
				ACESinput: false,
				ACESoutput: false,
			},
		});

		let lutFiles = [
			new File([exportedLUT1[0]], `${name}.IDTODT.${date}.cube`, { type: "text/plain" }),
			new File([exportedLUT2[0]], `${name}.LMT.${date}.cube`, { type: "text/plain" }),
		];

		// let LUT = new File([exportLUT[0]], `${name}.${date}.cube`, { type: "text/plain" });

		let matchData = {
			id: null,
			name: `${name}.${date}.jpg`,
			nicename: `${name}`,
			parent_id: vm.$store.getters["Projects/folderIdBySlug"]("matches"),
			bin_id: vm.$store.state.Projects.bin.id,
			type: "match",
			size: file.size,
			blob: file,
			thumbnail_name: thumbnailFile.name,
			thumbnail_size: thumbnailFile.size,
			imageIDTLMT,
			luts: lutFiles,
			blocks,
			blocksFile,
		};

		let uploadingFilesData = await vm.$store.dispatch("Projects/postUploadingFilesData", [matchData]);
		matchData.id = uploadingFilesData[0].file_id;
		matchData.thumbnail_id = uploadingFilesData[0].thumbnail_id;

		UI.appendToMatches(matchData);

		// store to indexedDB
		await uploadMatchesStore.setItem(matchData.id, {
			id: matchData.id,
			blob: matchData.blob,
			name: matchData.name,
			nicename: matchData.nicename,
			parent_id: matchData.parent_id,
			bin_id: matchData.bin_id,
			type: matchData.type,
			imageIDTLMT,
			// luts: matchData.luts,
			blocks: matchData.blocks,
			...(rawDevelopmentValues && { rawDevelopment: rawDevelopmentValues }),
			// blocksFile: matchData.blocksFile,
		});

		await thumbnailsStore.setItem(matchData.id, {
			project_id: vm.$store.state.Projects.project_id,
			folder_id: vm.$store.getters["Projects/folderIdBySlug"]("matches"),
			blob: thumbnailFile,
			file_id: matchData.thumbnail_id,
		});

		// await vm.$store.dispatch("Projects/refreshProjectTree");
		// await vm.$store.dispatch("Projects/refreshProjectTree", {
		// 	createPresignedURL: true,
		// });

		let promises = [];

		promises.push(
			vm.$store.dispatch("Projects/uploadToS3", {
				url: uploadingFilesData[0].filePresignedUrl,
				file,
			})
		);

		promises.push(
			vm.$store.dispatch("Projects/uploadToS3", {
				url: uploadingFilesData[0].thumbnailPresignedUrl,
				file: thumbnailFile,
			})
		);

		promises.push(
			vm.$store.dispatch("Projects/uploadToS3", {
				url: uploadingFilesData[0].imageIDTLMTPresignedUrl,
				file: imageIDTLMT,
			})
		);

		promises.push(
			vm.$store.dispatch("Projects/uploadToS3", {
				url: uploadingFilesData[0].blocksPresignedUrl,
				file: blocksFile,
			})
		);

		uploadingFilesData[0].luts.forEach((lut, lutKey) => {
			promises.push(
				vm.$store.dispatch("Projects/uploadToS3", {
					url: lut.lutPresignedUrl,
					file: lutFiles[lutKey],
				})
			);
		});

		await Promise.all(promises);

		let matchStoreData = await uploadMatchesStore.getItem(matchData.id);
		await uploadMatchesStore.removeItem(matchData.id);
		await matchesStore.setItem(matchStoreData.id, matchStoreData);

		await vm.$store.dispatch("Projects/updateFilesUploadStatus", [
			uploadingFilesData[0].file_id,
			uploadingFilesData[0].thumbnail_id,
			uploadingFilesData[0].imageIDTLMT_id,
			uploadingFilesData[0].blocks_id,
			uploadingFilesData[0].luts[0].lut_id,
			uploadingFilesData[0].luts[1].lut_id,
		]);
		await vm.$store.dispatch("Projects/refreshProjectTree");
		vm.$store.dispatch("Loader/showProgressBar", false);
	}

	async switchMatches() {
		vm.$store.dispatch("UI/removeMatches");
		let matchesList = vm.$store.getters["Projects/allMatches"];

		for await (const bin of matchesList) {
			for await (const match of bin.children) {
				await UI.appendToMatches({ ...match, placeholder: true }, false);
				let matchStoreData = await lutify.fetchMatch(match);
				await UI.appendToMatches({ ...match, blob: matchStoreData.blob }, false);
			}
		}
	}

	async updateImageThumbnail(image_id = null, src = null) {
		if (loader.typeOfActiveMedia('raw')) return;
		if (!image_id) image_id = vm.$store.state.Projects.image;
		if (!src) src = gpu.getOriginalImageSrc();

		let imageStoreData = await uploadImagesStore.getItem(image_id);
		if (!imageStoreData) imageStoreData = await imagesStore.getItem(image_id);

		let blob = loader.dataURLtoFile(src, `${imageStoreData.name}.thumbnail.jpg`);
		blob = await readAndCompressImage(blob, {
			quality: this.imageThumbnail.quality,
			maxWidth: this.imageThumbnail.maxWidth,
			maxHeight: this.imageThumbnail.maxHeight,
		});
		blob = new File([blob], `${imageStoreData.name}.thumbnail.jpg`);

		let thumbnailStoreData = await thumbnailsStore.getItem(image_id);
		// await thumbnailsStore.removeItem(image_id);
		// thumbnailStoreData.blob = blob;
		await thumbnailsStore.setItem(image_id, {...thumbnailStoreData, blob});

		vm.$store.dispatch('Projects/updateThumbnailObject', {
			file_id: image_id,
			blob
		});

		// vm.$store.dispatch("Projects/refreshProjectTree", false);

		// Pushing to server only when original thumbnail in uploading process has status "uploaded"
		let image = vm.$store.getters["Projects/imageById"](image_id);
		if (image && image.thumbnail.status == "uploaded") {
			let uploadFilesData = await vm.$store.dispatch("Projects/postThumbnailData", {
				file: blob,
				file_id: image_id,
			});

			await vm.$store.dispatch("Projects/uploadToS3", {
				url: uploadFilesData.presignedUrl,
				file: blob,
			});

			await vm.$store.dispatch("Projects/updateFilesUploadStatus", [uploadFilesData.file_id]);
		}
	}

	async updateCandidateThumbnail(candidate) {
		let nameWithTimestamp = stripExtension(candidate.name);
		let imageSrc = gpu.composer.renderer.domElement.toDataURL();
		let imageFile = loader.dataURLtoFile(imageSrc, `${nameWithTimestamp}.jpg`);

		let thumbnailFile = await readAndCompressImage(imageFile, {
			quality: this.imageThumbnail.quality,
			maxWidth: this.imageThumbnail.maxWidth,
			maxHeight: this.imageThumbnail.maxHeight,
		});
		thumbnailFile = new File([thumbnailFile], `${nameWithTimestamp}.thumbnail.jpg`);

		let thumbnailStoreData = await thumbnailsStore.getItem(candidate.id);
		// thumbnailStoreData.blob = thumbnailFile;
		await thumbnailsStore.setItem(candidate.id, {...thumbnailStoreData, blob: thumbnailFile});

		vm.$store.dispatch('Projects/updateThumbnailObject', {
			file_id: candidate.id,
			blob: thumbnailFile
		});

		// vm.$store.dispatch("Projects/refreshProjectTree", false);

		// Pushing to server only when original thumbnail in uploading process has status "uploaded"
		let candidateData = vm.$store.getters["Projects/candidateById"](candidate.id);
		if (candidateData && candidateData.thumbnail.status == "uploaded") {
			let uploadFilesData = await vm.$store.dispatch("Projects/postThumbnailData", {
				file: thumbnailFile,
				file_id: candidate.id,
			});

			await vm.$store.dispatch("Projects/uploadToS3", {
				url: uploadFilesData.presignedUrl,
				file: thumbnailFile,
			});

			await vm.$store.dispatch("Projects/updateFilesUploadStatus", [uploadFilesData.file_id]);
		}

		return thumbnailFile;
	}

	async addCandidate(name, notify = true) {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");

		let candidates = [];
		let postingCandidatesData = [];

		candidates.push(await this.createCandidateFiles(name));

		candidates.forEach(candidate => {
			postingCandidatesData.push({
				name: candidate.files.candidate.name,
				size: candidate.files.candidate.size,
				thumbnail_name: candidate.files.thumbnail.name,
				thumbnail_size: candidate.files.thumbnail.size,
				image_name: candidate.files.image.name,
				image_size: candidate.files.image.size,
				parent_id: candidate.data.parent_id,
				luts: candidate.files.luts,
			});
		});

		let uploadingFilesData = await vm.$store.dispatch("Projects/postUploadingCandidatesData", postingCandidatesData);
		let thumbnailsStoreData = [];
		let uploadCandidatesStoreData = [];

		// saving to indexedDB
		uploadingFilesData.forEach((data, key) => {
			candidates[key].data.id = data.candidate_id;
			// candidates[key].data.luts = candidates[key].files.luts;

			thumbnailsStoreData.push({
				key: candidates[key].data.id.toString(),
				value: {
					project_id: vm.$store.state.Projects.project_id,
					folder_id: candidates[key].data.parent_id,
					blob: candidates[key].files.thumbnail,
					thumbnail_id: data.thumbnail_id,
				},
			});

			uploadCandidatesStoreData.push({
				key: candidates[key].data.id.toString(),
				value: {
					...candidates[key].data,
					image: candidates[key].files.image
					// luts: candidates[key].files.luts
				}
			});
		});

		await thumbnailsStore.setItems(thumbnailsStoreData);
		await uploadCandidatesStore.setItems(uploadCandidatesStoreData);
		// await vm.$store.dispatch("Projects/refreshProjectTree");

		// NOTE: needs object to open, not id
		// let openProjectTree = [...vm.$store.state.Projects.openProjectTree];
		// openProjectTree.push(`${candidates[0].data.parent_id}-candidates`);
		// vm.$store.dispatch("Projects/openProjectTree", openProjectTree);

		for await (const candidate of candidates) {
			await UI.appendToCandidates(candidate.data, notify);
		}

		// updating project thumbnail
		gpu.render(); // Safari fix
		let file = loader.dataURLtoFile(gpu.renderer.domElement.toDataURL(), "project-thumbnail.png");
		this.updateProjectThumbnail(file);

		await this.uploadCandidates(uploadingFilesData, candidates);
		await this.updateCandidatesStatus(uploadingFilesData, candidates);

		await vm.$store.dispatch("Projects/refreshProjectTree");
		vm.$store.dispatch("Loader/showProgressBar", false);

		return candidates;
	}

	async createCandidateFiles(name) {
		let timestamp = Date.now();
		let nameWithTimestamp = `${name}.${timestamp}`;
		let files = {};
		let imageSrc;
		let blocks;

		gpu.render(); // Safari fix
		imageSrc = gpu.composer.renderer.domElement.toDataURL();
		blocks = _.cloneDeep(this.getRawBlocksData());

		let data = {
			id: null,
			name: `${nameWithTimestamp}.json`,
			nicename: name,
			// src: gpu.composer.renderer.domElement.toDataURL(),
			// imageFile,
			blocks,
			...(loader.typeOfActiveMedia('raw') && { rawDevelopment: {...vm.rawDevelopment.values} }),
			parent_id: vm.$store.state.Projects.image,
			bin_id: vm.$store.state.Projects.bin.id,
			type: "candidate",
		};

		let imageFile = loader.dataURLtoFile(imageSrc, `${name}.image.${timestamp}.jpg`);
		files.image = imageFile;

		let thumbnailBlob = await readAndCompressImage(imageFile, {
			quality: this.candidateThumbnail.quality,
			maxWidth: this.candidateThumbnail.maxWidth,
			maxHeight: this.candidateThumbnail.maxHeight,
		});
		files.thumbnail = new File([thumbnailBlob], `${name}.thumbnail.${timestamp}.jpg`);

		let exportedLUT1 = await luts.prepareExportLuts({
			name,
			options: {
				ACESinput: true,
				ACESoutput: true,
			},
		});

		let exportedLUT2 = await luts.prepareExportLuts({
			name,
			options: {
				ACESinput: false,
				ACESoutput: false,
			},
		});

		files.luts = [
			new File([exportedLUT1[0]], `${name}.IDTODT.${timestamp}.cube`, { type: "text/plain" }),
			new File([exportedLUT2[0]], `${name}.LMT.${timestamp}.cube`, { type: "text/plain" }),
		];

		let blocksCopy = [...data.blocks];
		if (data.rawDevelopment) {
			blocksCopy.unshift({
				name: 'RawDevelopment',
				values: data.rawDevelopment,
			});
		}


		files.candidate = new File([JSON.stringify(blocksCopy)], data.name, { type: "application/json" });

		return { data, files };
	}

	async uploadCandidates(uploadingFilesData, candidates) {
		let promises = [];

		uploadingFilesData.forEach((data, key) => {
			promises.push(
				vm.$store.dispatch("Projects/uploadToS3", {
					url: data.candidatePresignedUrl,
					file: candidates[key].files.candidate,
				})
			);

			promises.push(
				vm.$store.dispatch("Projects/uploadToS3", {
					url: data.thumbnailPresignedUrl,
					file: candidates[key].files.thumbnail,
				})
			);

			promises.push(
				vm.$store.dispatch("Projects/uploadToS3", {
					url: data.imagePresignedUrl,
					file: candidates[key].files.image,
				})
			);

			data.luts.forEach((lut, lutKey) => {
				promises.push(
					vm.$store.dispatch("Projects/uploadToS3", {
						url: lut.lutPresignedUrl,
						file: candidates[key].files.luts[lutKey],
					})
				);
			});
		});

		await Promise.all(promises);
	}

	async updateCandidatesStatus(uploadingFilesData, candidates) {
		let updateFileStatus = [];

		for await (const [key, data] of uploadingFilesData.entries()) {
			let candidateStoreData = await uploadCandidatesStore.getItem(candidates[key].data.id);
			await uploadCandidatesStore.removeItem(candidates[key].data.id);
			await candidatesStore.setItem(candidates[key].data.id, candidateStoreData);

			updateFileStatus.push(data.candidate_id);
			updateFileStatus.push(data.thumbnail_id);
			updateFileStatus.push(data.image_id);
			data.luts.forEach(lut => {
				updateFileStatus.push(lut.lut_id);
			});
		}

		await vm.$store.dispatch("Projects/updateFilesUploadStatus", updateFileStatus);
	}

	async switchCandidates(image_id) {
		vm.$store.dispatch("Loader/showProgressBar", "indeterminate");
		vm.$store.dispatch("UI/removeCandidates");

		let candidatesList = vm.$store.getters["Projects/candidates"](image_id);
		if (candidatesList) {
			for await (const candidate of candidatesList) {
				UI.container.compares.append(UI.createPlaceholder("show"));
				let candidateData = await this.fetchCandidate(candidate);
				await vm.$store.dispatch('Projects/fetchThumbnail', {
					file: candidate,
					project_id: vm.$store.state.Projects.project_id
				})
				UI.container.compares.find(".--placeholder").remove();
				await UI.appendToCandidates({ ...candidateData, item: candidate }, false);
			}
		}

		vm.$store.dispatch("Loader/showProgressBar", false);
	}

	// async fetchCandidateLuts(candidate) {
	// 	let luts = [];
	// 	for await (const [key, lut] of candidate.luts.entries()) {
	// 		if (key == 0) {
	// 			luts.push(undefined);
	// 			continue;
	// 		}
	//
	// 		luts.push(new File([await vm.$store.dispatch("Projects/fetchFile", lut.presign_url)], lut.name));
	// 	}
	//
	// 	return luts;
	// }

	async fetchCandidate(candidate, forceNewFetch = false) {
		let candidateData = await candidatesStore.getItem(candidate.id);
		if (!candidateData) candidateData = await uploadCandidatesStore.getItem(candidate.id);
		// if (candidateData && !forceNewFetch) console.log(`[CANDIDATE] [${candidate.id}] fetched from indexedDB`);

		if (!candidateData || forceNewFetch) {
			let candidateJSON = await vm.$store.dispatch("Projects/fetchFile", candidate.presignedURL);
			let candidateBlocks = await this.convertBlobToData(candidateJSON);

			let rawDevelopmentBlock = candidateBlocks.find(block => block.name == 'RawDevelopment');
			if (rawDevelopmentBlock) {
				candidateBlocks = candidateBlocks.filter(block => block.name !== 'RawDevelopment');
			}

			// NOTE: maybe we can upload larger thumbnails to avoid rendering for larger thumbnail
			// let imageSrc = await this.getCandidateImage(candidateBlocks);
			// let file = loader.dataURLtoFile(imageSrc, `${stripExtension(candidate.name)}.jpg`);

			candidateData = {
				id: candidate.id,
				name: candidate.name,
				nicename: stripTimestampAndExtension(candidate.name),
				blocks: candidateBlocks,
				...(rawDevelopmentBlock && { rawDevelopment: rawDevelopmentBlock.values }),
				parent_id: vm.$store.state.Projects.image,
				bin_id: vm.$store.state.Projects.bin.id,
				type: "candidate",
			};

			if (vm.$store.getters['User/isGuest']) {
				// let luts = await this.fetchCandidateLuts(candidate);
				// candidateData.luts = luts;

				if (candidate.image) {
					candidateData.image = await vm.$store.dispatch("Projects/fetchFile", candidate.image.presign_url);
				}
			}


			await candidatesStore.setItem(candidate.id, candidateData);
			// await thumbnailsStore.setItem(candidate.id, {
			// 	project_id: vm.$store.state.Projects.project_id,
			// 	folder_id: candidates[key].data.parent_id,
			// 	src: candidates[key].files.thumbnailSrc,
			// 	thumbnail_id: data.thumbnail_id,
			// });
			// console.log(`[CANDIDATE] [${candidate.id}] fetched from S3`);
		}

		return candidateData;
	}

	async fetchCandidateImage(candidate) {
		const image = await vm.$store.dispatch("Projects/fetchFile", candidate.image.presign_url);

		const storeData = await candidatesStore.getItem(candidate.id);
		if (storeData) {
			storeData.image = image;
			await candidatesStore.setItem(candidate.id, storeData);
		}

		return image;
	}

	// async getCandidateImage(blocks) {
	// 	this.saveCurrentSelections();
	// 	await this.applyCompare(blocks, null, false);
	// 	let src = gpu.renderer.domElement.toDataURL();
	// 	await this.applyCompare(lutify.currentSelections.blocks, null, false);
	// 	return src;
	// }

	async updateProjectThumbnail(file, project_id = null, convertImage = false) {
		if (!project_id) project_id = vm.$store.state.Projects.project.id;
		let projectThumbnailName = `${project_id}.project.thumbnail.${Date.now()}.jpg`;

		let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);

		if (loader.isEXRFile(fileType)) return;
		if (loader.isVideoFile(fileType)) return;

		if (convertImage) {
			let convertedImage = await loader.convertImage(file, fileType);
			file = convertedImage.blob;

			if (loader.isRawFile(fileType)) {
				file = await vm.rawDevelopment.extractThumbnailFromRaw(file);
			}
		}

		let projectThumbnailBlob = await readAndCompressImage(file, {
			quality: lutify.projectThumbnail.quality,
			maxWidth: lutify.projectThumbnail.maxWidth,
			maxHeight: lutify.projectThumbnail.maxHeight,
		});

		// renaming file
		projectThumbnailBlob = new File([projectThumbnailBlob], projectThumbnailName);

		IDB.projectsThumbnailsStore.setItem(project_id, {
			blob: projectThumbnailBlob,
		});

		vm.$store.dispatch("Projects/setProjectFeaturedImage", {
			project_id,
			blob: projectThumbnailBlob,
		});

		let uploadFilesData = await vm.$store.dispatch("Projects/postThumbnailData", {
			file: projectThumbnailBlob,
		});

		await vm.$store.dispatch("Projects/uploadToS3", {
			url: uploadFilesData.presignedUrl,
			file: projectThumbnailBlob,
		});

		await vm.$store.dispatch("Projects/updateFilesUploadStatus", [uploadFilesData.file_id]);
	}

	convertBlobToData(blob) {
		return new Promise(resolve => {
			let fr = new FileReader();
			fr.onload = () => {
				resolve(JSON.parse(fr.result));
			};
			fr.readAsText(blob);
		});
	}

	getImageSizeFromBlob(blob) {
		return new Promise(resolve => {
			let url = URL.createObjectURL(blob);
			let img = new Image;

			img.onload = function() {
				let data = {
					width: img.width,
					height: img.height
				}

				URL.revokeObjectURL(img.src);
				resolve(data);
			};

			img.src = url;
		});
	}

	// removeAllCandidates() {
	// 	UI.container.compares.find(".btn-delete-compare").each((i, btn) => $(btn).trigger("click"));
	// }

	// removeAllMatches() {
	// 	UI.container.matches.find(".btn-delete-match").each((i, btn) => $(btn).trigger("click"));
	// }

	async applyCompare(applyBlocks, waitToLoad = false, notify = true) {
		blocks.removeAllDynamic();

		let showColorWorkflowPresetNotification = false;
		this.applyingCandidate = true;

		UI.toggleStartTips();

		// We are using for..of because of async/await
		for await (const [index, block] of applyBlocks.entries()) {
			// Render block
			if (index == 0) continue;
			if (block.name == 'RawDevelopment') continue;

			// IDT
			if (index == 1) {
				gpu.updateIDT(block.values, false); // don't show notification
				UI.IDT.btn.find(".menu-label").html(block.values.label);
				if (block.values.value == "IDT100") showColorWorkflowPresetNotification = true;
				if (lutify.fixBlueLightArtifacts !== block.fixBlueLightArtifacts) {
					vm.$nextTick(() => {
						vm.$root.$refs.fixBlueLightButton.$el.click()
					})
				}
				// eslint-disable-next-line no-prototype-builtins
				if ((!block.hasOwnProperty('gamutCompress') && !block.fixBlueLightArtifacts && !block.values.initial && !lutify.gamutCompress) || (block.hasOwnProperty('gamutCompress') && lutify.gamutCompress !== block.gamutCompress)) {
					vm.$nextTick(() => {
						vm.$root.$refs.gamutCompressComponent.setGamutCompress();
					})
				}
				continue;
			}

			// ODT
			if (index == applyBlocks.length - 1) {
				gpu.updateODT(block.values, false); // don't show notification
				UI.ODT.btn.find(".menu-label").html(block.values.label);
				if (block.values.value == "ODT400") showColorWorkflowPresetNotification = true;
				continue;
			}

			let blockNum = blocks.getNewBlockNumber();
			let data;

			// Pseudo controls
			if (block.control && block.category) {
				data = {
					control: block.control,
					category: block.category,
					active: block.active,
					blendingMode: block.blendingMode,
					collapsedPreviews: block.collapsedPreviews,
					...(block.predictionsContent) && { predictionsContent: block.predictionsContent }
				};
				await _Adjustments[block.name].addBlock(blockNum, data);
				let $blockEl = UI.getBlock(blockNum);
				_Adjustments[block.name].applyChanges($blockEl, block.values, data);
			}

			// LUT controls
			else if (block.control == "LUTcontrols") {
				data = {
					category: block.name,
					control: block.control,
					selectedPreview: block.selectedPreview,
					selectedPreviewName: block.selectedPreviewName,
					blendingMode: block.blendingMode,
					opacity: block.opacity,
					active: block.active,
					collapsedPreviews: block.collapsedPreviews,
					...(block.product) && {product: block.product}
				};
				await _Adjustments[block.control].addBlock(blockNum, data);
				let $blockEl = UI.getBlock(blockNum);
				_Adjustments[block.control].applyCompare($blockEl, data);
			}

			// custom LUT
			else if (block.control == "customLUT" || block.control == "CustomLutV2") {
				if (vm.$store.getters["User/isCurrentPlanFree"]) continue;

				data = {
					control: block.control,
					category: null,
					folder: block.folder,
					lut: block.lut,
					lutContent: block.lutContent,
					lutOwner: block.lutOwner,
					lutName: block.lutName,
					lutId: block.lutId,
					...(block.colorSpace) && {colorSpace: block.colorSpace},
					inputColorSpace: block.inputColorSpace,
					outputColorSpace: block.outputColorSpace,
					blendingMode: block.blendingMode,
					opacity: block.opacity,
					active: block.active,
					collapsedPreviews: block.collapsedPreviews,
				};
				await _Adjustments[block.control].addBlock(blockNum, data);
				let $blockEl = UI.getBlock(blockNum);
				await _Adjustments[block.control].applyCompare($blockEl, data);
			}

			// Legacy Magic Mode
			else if (block.name == "magicMode") {
				data = {
					name: block.name,
					control: block.control,
					selectedPreview: block.selectedPreview,
					selectedPreviewName: block.selectedPreviewName,
					selectedPreviewCategory: block.selectedPreviewCategory,
					blendingMode: block.blendingMode,
					opacity: block.opacity,
					active: block.active,
					collapsedPreviews: block.collapsedPreviews,
					waitToLoad,
				};
				await _Adjustments[block.name].addBlock(blockNum, data);
				let $blockEl = UI.getBlock(blockNum);
				_Adjustments[block.name].applyCompare($blockEl, data);
			}

			else if (['AIMagicMode', 'AIExposure', 'AIContrast', 'AIWhiteBalance'].includes(block.name)) {
				data = {
					name: block.name,
					control: block.control,
					selectedPreview: block.selectedPreview,
					selectedPreviewName: block.selectedPreviewName,
					selectedPreviewCategory: block.selectedPreviewCategory,
					blendingMode: block.blendingMode,
					opacity: block.opacity,
					active: block.active,
					collapsedPreviews: block.collapsedPreviews,
					waitToLoad,
					...(block.predictionsContent) && { predictionsContent: block.predictionsContent }
				};
				await _Adjustments[block.name].addBlock(blockNum, data);
				let $blockEl = UI.getBlock(blockNum);
				await _Adjustments[block.name].applyCompare($blockEl, data);
			}

			// Normal controls
			else {
				await _Adjustments[block.name].addBlock(blockNum, block);
				let $blockEl = UI.getBlock(blockNum);
				await _Adjustments[block.name].applyChanges($blockEl, block.values, block);
				if (block.blendingMode !== 0)
					$blockEl.find(`.blending-mode__items-container > span[data-id="${block.blendingMode}"]`).trigger("click");
			}

			if (block.active) {
				if (
					!UI.getActiveBlock()
						.find(".controls-wrapper .switch input")
						.is(":checked")
				) {
					UI.getActiveBlock()
						.find(".controls-wrapper .switch input")
						.trigger("click");
				}
			} else {
				if (
					UI.getActiveBlock()
						.find(".controls-wrapper .switch input")
						.is(":checked")
				) {
					UI.getActiveBlock()
						.find(".controls-wrapper .switch input")
						.trigger("click");
				}
			}

			UI.getActiveBlock()
				.find(".collapse_options")
				.trigger("click");
			UI.getActiveBlock().removeClass("selected_block");
			UI.hideLUTtemplates();
		}

		lutify.activeBlock = null;
		this.applyingCandidate = false;
		// UI.removeCompareLoadingSpinner();

		UI.toggleStartTips();

		//Show notification when loading a preset with no IDT/ODT
		if (showColorWorkflowPresetNotification && notify) {
			UI.showColorWorkflowPresetNotification();
		}
	}

	showScopes() {
		UI.showScopes();
		vm.$store.dispatch('Scopes/setScopesEnabled', true);
		gpu.render(); // fix for safari
	}

	hideScopes() {
		UI.hideScopes();
		vm.$store.dispatch('Scopes/setScopesEnabled', false);
	}

	getRawBlocksData(omitProperties = []) {
		let data = [];

		lutify.blocks.forEach(block => {
			block = _.omit(block, ["curves", "colorWheels", "passes", "samplePixels", "targetPixels", "lutObjects", "predictions", ...omitProperties]);
			data.push(block);
		});

		return data;
	}

	getSelectedBlocksList() {
		let data = [];

		lutify.blocks.forEach(block => {
			let blockData = {};
			blockData.name = block.name;
			if (block.control) blockData.control = block.control;
			if (block.category) blockData.category = block.category;
			data.push(blockData);
		});

		data.splice(0, 2);
		data.splice(data.length - 1, 1);

		return data;
	}

	async fetchPreset(id) {
		let presetData = await presetsStore.getItem(id);
		if (!presetData) {
			let url;
			vm.$store.state.UserFiles.presets.forEach(presetFolder => {
				presetFolder.files.find(preset => {
					if (preset.id == id) url = preset.presignedURL;
				});
			});

			presetData = await vm.$store.dispatch("UserFiles/fetchFile", url);
			presetsStore.setItem(id, presetData);
		}

		return presetData;
	}

	async applyPreset(blocksData) {
		// let blocksData = _.cloneDeep(this.savedLUT[folder][index].blocks);

		// Transforms mismatch
		if (
			(this.selectedIDT && blocksData[1].values.name !== this.selectedIDT.name) ||
			(this.selectedODT && blocksData[blocksData.length - 1].values.name !== this.selectedODT.name)
		) {
			UI.hideModal();
			UI.showModal(UI.modals.presets.transformsMismatch.el);

			let transformsAction = await UI.presetTransformsSelection();
			if (transformsAction == "keep-transforms") {
				blocksData[1].values = lutify.selectedIDT;
				blocksData[blocksData.length - 1].values = lutify.selectedODT;
			}

			UI.hideModal();
			await this.applyCompare(blocksData, "waitToLoad");
		} else await this.applyCompare(blocksData, "waitToLoad");

		lutify.updateImageThumbnail();
	}

	hideBlockSelections() {
		if (vm.$store.getters['User/isGuest']) return;

		lutify.activeBefore = true;
		UI.label.showImageBeforeLabel();
		if (lutify.activeBefore && !lutify.canvasMouseDown && !lutify.bubbleMessage) UI.message.activate(UI.message.texts.inBeforeMode, "stay");

		lutify.removeSplitView();
		lutify.tempSavedBlocksState = [];

		blocks.getDynamicBlocks().forEach(block => {
			lutify.tempSavedBlocksState.push(block.active);

			if (block.active) {
				const $block = UI.getBlock(block.blockNum);
				const $switch = $block.find(".controls-wrapper .switch > input");

				block.active = 0;
				blocks.storePassesEnabledStatus(block);
				blocks.disablePasses(block);

				$block.addClass("--off");
				$switch.prop("checked", false);
			}
		});

		gpu.render();
		lutPreviewer.render();
	}

	showBlockSelections() {
		if (vm.$store.getters['User/isGuest']) return;

		UI.label.hideImageBeforeLabel();
		UI.message.deactivate();
		lutify.bubbleMessage = false;

		blocks.getDynamicBlocks().forEach((block, i) => {
			if (lutify.tempSavedBlocksState[i] && !block.active) {
				const $block = UI.getBlock(block.blockNum);
				const $switch = $block.find(".controls-wrapper .switch > input");

				block.active = 1;
				blocks.enablePasses(block);

				$block.removeClass("--off");
				$switch.prop("checked", true);
			}
		});

		gpu.render();
		lutPreviewer.render();

		lutify.activeBefore = false;
		delete lutify.tempSavedBlocksState;
	}

	async applyLayout(id) {
		let blocksList = await this.fetchLayout(id);

		for await (const [index, block] of blocksList.entries()) {
			let data = {
				name: block.name,
				control: block.control,
				category: block.category,
			};

			if (block.control == "LUTcontrols" || block.control == "customLUT" || block.control == 'CustomLutV2') {
				data.category = block.name;
				await _Adjustments[data.control].addBlock(blocks.getNewBlockNumber(), data);
			} else {
				await _Adjustments[data.name].addBlock(blocks.getNewBlockNumber(), data);
			}

			UI.getActiveBlock()
				.find(".collapse_options")
				.trigger("click");
			UI.getActiveBlock().removeClass("selected_block");
			UI.hideLUTtemplates();
		}

		lutify.activeBlock = null;
	}

	async fetchLayout(id) {
		let data = await layoutsStore.getItem(id);
		if (!data) {
			data = await vm.$store.dispatch(
				"UserFiles/fetchFile",
				vm.$store.state.UserFiles.layouts.find(layout => layout.id == id).presignedURL
			);
			layoutsStore.setItem(id, data);
		}

		return data;
	}

	testInputRegex(str) {
		let regex = new RegExp(/^[a-zA-Z0-9-._ ()]+$/);
		return regex.test(str);
	}

	toggleIDTODT(blocks) {
		if (blocks[1].values.initial) {
			this.selectedIDT = false;
			this.selectedODT = false;
			UI.resetIDTODT();
			vm.$store.dispatch("App/resetActiveIDT");
		} else UI.enableODT();
	}

	async applyLastState(file_id = null) {
		let imageState = await this.fetchLastState(file_id);

		await this.applyCompare(imageState.blocks, "waitToLoad", false);

		this.toggleIDTODT(imageState.blocks);

		UI.toggleImageTools();
	}

	async fetchLastState(file_id = null) {
		let imageState;

		if (file_id) {
			imageState = await imagesStateStore.getItem(file_id);

			if (!imageState) {
				let response = await vm.$store.dispatch("UserFiles/fetchLastState", file_id);
				if (response.length == 0) {
					imageState = {
						timestamp: Date.now(),
						blocks: this.initialBlocks,
					};
					// console.log(`[LAST STATE] initial state`);
				} else {
					// console.log(`[LAST STATE] [${file_id}] fetched from API`);
					imageState = {
						timestamp: response.timestamp,
						blocks: response.blocks,
						...(response.rawDevelopment && { rawDevelopment: response.rawDevelopment })
					};
					await imagesStateStore.setItem(file_id, imageState);
				}
				// }
			}
		} else {
			// when reseting scene
			// console.log(`[LAST STATE] initial state`);
			imageState = {
				timestamp: Date.now(),
				blocks: this.initialBlocks,
			};
		}

		return imageState;
	}

	async refreshLastStates(files = null) {
		let response = await vm.$store.dispatch("UserFiles/fetchLastStatesByProject");
		if (files) response = response.filter(item => files.map(e => e.id).includes(item.id));
		// console.log("[LAST STATES] to process", response);

		let lastStatesStore = await imagesStateStore.getItems(response.map(e => e.id.toString()));
		let lastStatesToStore = [];

		for (const image of response) {
			if (lastStatesStore[image.id]) continue;

			let lastState;

			if (image.last_state.length > 0) {
				lastState = await vm.$store.dispatch("UserFiles/fetchFile", image.last_state[0].presign_url);
				// console.log(`[LAST STATE] [${image.id}] fetched from S3`, lastState);
			} else {
				lastState = {
					timestamp: Date.now(),
					blocks: this.initialBlocks,
				};

				// console.log(`[LAST STATE] [${image.id}] initial last state`, lastState);
			}

			lastStatesToStore.push({
				key: image.id.toString(),
				value: lastState,
			});
		}

		await imagesStateStore.setItems(lastStatesToStore);
	}

	async postLastStates(list) {
		let lastStates = [];
		let batchMaxSize = 100;
		let lastStateBatches = [];
		let batchList = [];

		list.forEach(item => {
			let file = new File([JSON.stringify(item.lastStateData)], `${item.image_id}.${item.lastStateData.timestamp}.json`, {
				type: "application/json",
			});

			lastStates.push({
				image_id: item.image_id,
				file,
			});
		});

		// creating batches
		lastStates.forEach((lastState, key) => {
			if (batchList.length < batchMaxSize) {
				batchList.push(lastState);
			}

			if (batchList.length == batchMaxSize || key == lastStates.length - 1) {
				lastStateBatches.push(batchList);
				batchList = [];
			}
		});

		if (!this.canUseColorGradingTools()) return;

		lastStateBatches.forEach(lastStateBatch => {
			vm.$store.dispatch("UserFiles/postLastState", {
				project_id: vm.$store.state.Projects.project.id,
				lastStates: lastStateBatch,
			});
		});
	}

	// Saving to local storage
	async storeLastState(file_id = null, blocks = null, previousMedia = false, rawDevelopmentValues = null) {
		if (!this.canUseColorGradingTools()) return;

		if (!file_id) file_id = vm.$store.state.Projects.image;
		if (!file_id || !vm.$store.getters['Projects/imageById'](file_id)) return;

		if (!blocks) blocks = _.cloneDeep(lutify.getRawBlocksData());

		let data = {
			timestamp: Date.now(),
			blocks,
		}

		let lastStateStore = await imagesStateStore.getItem(file_id);

		if (!lastStateStore ||
			lastStateStore.needsSync ||
			JSON.stringify(lastStateStore.blocks) !== JSON.stringify(blocks)) {
			data.needsSync = true;
		}

		if (rawDevelopmentValues) {
			data.rawDevelopment = rawDevelopmentValues;
		} else {
			if (previousMedia && loader.isRawFile(previousMedia.type)) {
				data.rawDevelopment = vm.rawDevelopment.values;
			} else if (loader.typeOfActiveMedia('raw')) {
				data.rawDevelopment = vm.rawDevelopment.values;
			}
		}

		await imagesStateStore.setItem(file_id, data);
	}

	// saving to server
	async pushLastStates(forActiveImageOnly = false, project_id = null) {
		if (!this.canUseColorGradingTools()) return;

		if (!project_id) project_id = vm.$store.state.Projects.project.id;
		if (!project_id) return;

		let mediaKeysList = forActiveImageOnly ? [vm.$store.state.Projects.image.toString()] : vm.$store.getters['Projects/allMediaOfProject'].map(file => file.id.toString());
		if (Object.keys(mediaKeysList).length == 0) return;

		let storeList = await imagesStateStore.getItems(mediaKeysList);
		if (Object.keys(storeList).length == 0) return;

		let uploadList = [];
		let updatingStoreList = {};

		Object.keys(storeList).forEach(file_id => {
			if (!storeList[file_id].needsSync) return;

			storeList[file_id].needsSync = false;
			updatingStoreList[file_id] = { ...storeList[file_id] };

			let data = JSON.stringify({
				timestamp: storeList[file_id].timestamp,
				blocks: storeList[file_id].blocks,
				...(storeList[file_id].rawDevelopment && { rawDevelopment: storeList[file_id].rawDevelopment })
			});

			let file = new File(
				[data],
				`${file_id}.json`,
				{
					type: "application/json",
				}
			);

			uploadList.push({
				image_id: file_id,
				file,
			})
		})

		if (uploadList.length == 0) return;

		await vm.$store.dispatch("UserFiles/postLastState", {
			project_id,
			lastStates: uploadList,
		});

		await imagesStateStore.setItems(updatingStoreList);

		// let fd = new FormData();
		// fd.append("files[0][image_id]", file_id);
		// fd.append("files[0][file]", file);
		//
		// let url = `${vm.$apiService.axios.defaults.baseURL}accounts/${vm.$store.state.User.account.id}/projects/${vm.$store.state.Projects.project.id}/files/${file_id}/last-state`;
		//
		// fetch(url, {
		// 	method: "POST",
		// 	data: fd,
		// 	headers: {
		// 		Authorization: "Bearer " + localStorage.getItem("access_token"),
		// 	},
		// 	keepalive: true,
		// 	body: fd,
		// });
	}

	isCurrentPlanFree() {
		if (vm.$store.state.User.account.plan_id == 1) return true;
		else return false;
	}

	canExportLUT() {
		// if (this.isCurrentPlanFree()) return false;
		if (vm.$store.state.User.account.role_id >= 6) return false;
		else return true;
	}

	canUsePresets() {
		// if (this.isCurrentPlanFree()) return false;
		if (vm.$store.state.User.account.role_id >= 6) return false;
		else return true;
	}

	canSaveFullSizeImage() {
		if (this.isCurrentPlanFree()) return false;
		else return true;
	}

	canCreateAssets() {
		if (vm.$store.state.User.account.role_id >= 6) return false;
		else return true;
	}

	canUseColorGradingTools() {
		if (vm.$store.state.User.account.role_id >= 6) return false;
		else return true;
	}

	canUseScopes() {
		if (vm.$store.state.User.account.role_id == 7) return false;
		else return true;
	}

	markNewCommentNotificationsAsRead() {
		if (vm.$store.state.Projects.image && document.hasFocus()) {
			let notifications = [];
			if (vm.$store.getters["User/isGuest"]) notifications = vm.$store.getters["Notifications/newCommentNotificationsOfFile"](vm.$store.state.Projects.currentFile.parent_file_id, 'shared');
			else notifications = vm.$store.getters["Notifications/newCommentNotificationsOfFile"](vm.$store.state.Projects.image, vm.$store.state.Comments.currentChannel);

			if (notifications.length > 0) {
				vm.$store.dispatch("Notifications/markAsRead", notifications);
			}
		}
	}

	async createCandidateAndAutoShare() {
		let newCandidateName = vm.$store.getters["Projects/newAutoCandidateName"];
		let newCandidates = await lutify.addCandidate(newCandidateName);
		let newCandidateId = newCandidates[0].data.id;

		vm.$store.dispatch("Projects/setCurrentFile", vm.$store.getters["Projects/candidateById"](newCandidateId));
		window.UI.container.compares.find(`.candidate-container[data-index="${newCandidateId}"] img`).trigger("click");

		return newCandidateId;
	}
}
